import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiFormHelperText: Components<Theme>['MuiFormHelperText'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.Mui-error': {
        color: theme.palette.error.contrastText,
        marginLeft: '16px',
        fontWeight: 500,
      },
    }),
  },
};
